KMVP.kmcQuoteEditTemplating = {
    applyTemplateChanges: function(quoteId, quoteEditData) {
        quoteEditData.forEach(function(data) {
            KMVP.kmcQuoteEditTemplating.applyRowChanges(quoteId, data);
        })
    },
    applyRowChanges: function(quoteId, data) { // data -> entryLineRecord
        if (Number(data.newQuantity) === Number(data.oldQuantity)) {
            this.rowChangeUndo(quoteId, data);
        } else if (Number(data.newQuantity) === 0) {
            this.rowChangeDelete(quoteId, data);
        } else {
            this.rowChangeEdit(quoteId, data);
        }
    },
    rowChangeEdit: function(quoteId, data) {
        $('.js-quote-line-item-row-' + quoteId + '-' + data.entryLine)
            .addClass('js-quote-line-item-edited')
            .removeClass('js-js-quote-line-item-deleted')
            .find('.js-quote-entry-pieces')
            .text(this.formatNumber(data.newQuantity) + ' PCS' )
    },
    formatNumber: function(number) {
        return String(number).replace(/\d{1,3}(?=(\d{3})+(?!\d))/g , "$&,");
    },
    rowChangeDelete: function(quoteId, data) {
        $('.js-quote-line-item-row-' + quoteId + '-' + data.entryLine)
            .addClass('js-quote-line-item-deleted')
            .removeClass('js-quote-line-item-edited')
    },
    rowChangeUndo: function(quoteId, data) {
        $('.js-quote-line-item-row-' + quoteId + '-' + data.entryLine)
            .removeClass('js-quote-line-item-edited')
            .removeClass('js-quote-line-item-deleted')
            .find('.js-quote-entry-pieces')
            .text(data.oldQuantity + ' PCS' )
    },
    applyQuotePageChanges: function(quoteEditData) {
        if (quoteEditData && quoteEditData.length) {
            $('.js-kmc-quote-detail-page').addClass('quote-edited');
        } else {
            $('.js-kmc-quote-detail-page').removeClass('quote-edited');
        }
    },

    getCurrentQuoteId: function() {
        return $('.js-kmc-quote-detail-page').data('quoteId');
    },
    getQuoteEditSubmitUrl: function() {
        return $('.js-submit-quote-edit').data('quoteEditSubmitUrl');
    },

    // submitting quote edit
    isPageBlocked: function() {
        return $('.js-kmc-quote-detail-page').hasClass('form-blocked');
    },
    blockPage: function() {
        $('.js-kmc-quote-detail-page').addClass('form-blocked');
        $('.js-kmc-quote-detail-page .js-submit-quote-edit').showSpinner();
    },
    unblockPage: function() {
        $('.js-kmc-quote-detail-page').removeClass('form-blocked');
        $('.js-kmc-quote-detail-page .js-submit-quote-edit').hideSpinner();
    },
};
